export default __webpack_public_path__ + "static/media/otros.bbf62091.svg";